/**
 * Width of the question-number column, sized to the longest number on the
 * bid ("2.1" and "PQQ.10" alike) so numbers never run into titles. Capped so
 * a very long number truncates rather than squeezing the title.
 */
export const numberColumnStyle = (numbers: (string | null | undefined)[]): { width: string } => {
  const longest = Math.max(1, ...numbers.map((n) => (n ?? "").length));
  return { width: `${Math.min(longest, 9) + 0.5}ch` };
};

export const NUMBER_CLASS = "shrink-0 truncate whitespace-nowrap text-xs font-semibold tabular-nums text-fg-3";
